module.exports = __webpack_public_path__ + "static/media/Coltar-Ceramic-Klinker-240X115-X-71-X-10---Gobi-(HF14).63bd451d.jpg";